<template>
  <DxPopup @hidden="onHidden" :visible="showIeSettingPop" :show-close-button="true" :show-title="true" :title="menuTitle" height="850" width="1280" container=".v-application">
    <div class="h-full">
      <DxScrollView
        width="100%"
        height="100%"
        direction="both"
      >
        <OL type="A" style="font-size:12pt;">
          <LI>Website Information - http://hycot.hvs.com.vn</LI>
            <OL type="1" style="font-size:10pt;">
              <LI>Users : all suppliers have commercial relation with HD Hyundai-Vietnam ShipBuiding Co., Ltd.(HVS).</LI>
              <LI>Internet Explore Setting</LI>
                <OL type="i" style="font-size:10pt;">
                  <LI>
                    Add 'http://*.hycot.hvs.com.vn' to Trusted sites.<br>
                    (1)Open Internet Option and select Security<br>
                    <img :src="require(`@/assets/images/etc/ie_setting_00_Option2.jpg`)" width="600"><br>
                    (2)Add Trusted sites<br>
                    <img :src="require(`@/assets/images/etc/ie_setting_00_setting2.jpg`)" width="300"><br>
                  </LI>
                  <LI>
                    Turn Off pop-up Blockers : You must turn off IE's Pop-up Blockers as follow image.<br>
                    <img :src="require(`@/assets/images/etc/ie_setting_01_turnoff_popup2.jpg`)" width="600"><br>
                    or set internet option as follow images.<br>
                    <img :src="require(`@/assets/images/etc/ie_setting_02_Option2.jpg`)" width="600"><br>
                    <img :src="require(`@/assets/images/etc/ie_setting_03_set_blocker2.jpg`)" width="600"><br><br>
                  </LI>
                  <LI>
                    Dont' use toolbar. (ex, Google toolbar, Yahoo toolbar) - If you use the toolbar, the toolbar can protect pop-up.<br>
                    <img :src="require(`@/assets/images/etc/ie_setting_04_toolbar2.jpg`)" width="600"><br><br>
                  </LI>
                </OL>
              <LI>Login : USER ID and PASSWORD</LI>
                <OL type="i" style="font-size:10pt;">
                  <LI>USER ID:</LI>
                    <OL type="a" style="font-size:10pt;">
                      <LI>USER ID is a supplier code which is created by HVS(Each supplier code, Exp:Supplier code of A company is 10001, B company is 10002, ...).</LI>
                      <LI>
                        If customers do not have a customer code, please contact us at :<br>
                        Purchase Section, Procurement Department, HD Hyundai-VietNam ShipBuilding Co., Ltd.<br>
                        No. 01, Mỹ Giang, Ninh Phước, Ninh Hòa, Khán Hòa, Việt Nam,<br>
                        Tel : 0583.622101, Fax : 0583.622047, E-mail : hvs@hvs.com.vn
                      </LI>
                    </OL>
                  <LI>PASSWORD:</LI>
                    <OL type="a" style="font-size:10pt">
                      <LI>First password for a new user : v + customer code (exp: USER ID : 10001, PASSWORD : 10001).</LI>
                      <LI>You can change to new password by yourself from current password.</LI>
                      <LI>If you lose or forget your password, in this case the supplier must come to our company directly and bring documents relating to your company to prove with Material department before Material department create a new password(in order to the information security of users.).</LI>
                    </OL>
                  <LI>The purpose of the Quotation request to find a supplier with price and technical standards of the purchase of materials to suit the available cost and made good quality of our products.<br><br></LI>
                </OL>
            </OL>
          <LI>Adobe Reader:</LI>
            <OL type="1" style="font-size:10pt;">
              <LI>
                The program uses Adobe Reader for print.<br>
                If you have not installed Adobe Reader, click follow button and install program.<br>
                <v-btn small @click.stop="clickAdobe" class="mb-1" color="primary">
                  <v-icon small class="mt-n1">
                    mdi-arrow-right-box
                  </v-icon>
                  Adobe Reader
                </v-btn>
              </LI>
            </OL>
        </OL>
      </DxScrollView>
    </div>
  </DxPopup>
</template>

<script>
import baseview from '@/components/base/baseview'
import { DxPopup } from 'devextreme-vue/popup'
import { DxScrollView } from 'devextreme-vue/scroll-view'

export default {
  name: 'ieSettingPop',
  mixins: [baseview],
  components: {
    DxPopup,
    DxScrollView
  },
  props: {
    showIeSettingPop: {
      type: Boolean,
      default() {
        return false
      }
    }
  },
  data() {
     return {
       menuTitle: 'How To IE Setting',
       openChk: false
     }
  },
  watch: {
    'showIeSettingPop': {
      handler(value, oldValue) {
        if(value) {
          this.init()
        }
      },
      immediate: true
    }
  },
  methods: {
    init() {
    },
    clickAdobe() {

    },
    onHidden(e) {
      this.$emit('update:showIeSettingPop', false)
    }
  }
}
</script>

<style lang="scss" scoped>
.v-btn {
  text-transform: unset !important;
}
</style>